import { render, staticRenderFns } from "./RechargeHistories.vue?vue&type=template&id=67bc78d4&"
import script from "./RechargeHistories.vue?vue&type=script&lang=ts&"
export * from "./RechargeHistories.vue?vue&type=script&lang=ts&"
import style0 from "./RechargeHistories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports